export const defaultStyles = {
  backgroundColor: "var(--theme-email-color-background-secondary)",
  padding: {
    paddingTop: "64",
    paddingBottom: "64",
    paddingRight: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginRight: "0",
    marginLeft: "0",
  },
} as const;
